export const Price = [
  {
    _id: 0,
    name: "sh. 250K to sh. 500K",
    array: [250000, 500000],
  },
  {
    _id: 1,
    name: "sh. 500K to sh. 1M",
    array: [500000, 1000000],
  },
  {
    _id: 2,
    name: "sh. 1M to sh. 2M",
    array: [1000000, 2000000],
  },
  {
    _id: 3,
    name: "sh. 2M to sh. 3M",
    array: [2000000, 3000000],
  },
  {
    _id: 4,
    name: "sh. 3M to sh. 4M",
    array: [3000000, 4000000],
  },
  {
    _id: 4,
    name: "sh. 4M to sh. 5M",
    array: [4000000, 5000000],
  },
  {
    _id: 5,
    name: "sh. 5M to sh. 50M",
    array: [5000000, 50000000],
  },
];
